<script setup lang="ts">
import { computed } from 'vue';

import { BaseButton, BaseIcon } from '@magma-app/magma-lapilli';

import ManageRewardsHeroIcon from './ManageRewardsHeroIcon.vue';

const props = defineProps<{
  title?: string | null;
  description?: string | null;
  closeCta?: string | null;
}>();

const emit = defineEmits<{
  (event: 'close'): void;
}>();

const resolvedTitle = computed(() => props.title || '');
const resolvedDescription = computed(() => props.description || '');
</script>

<template>
  <div>
    <div class="mb-4 flex justify-between">
      <ManageRewardsHeroIcon variant="success" />

      <BaseIcon
        icon="close"
        color="#5F6C85"
        hover-state
        @click="emit('close')"
      />
    </div>

    <h3 class="mb-2 text-mgm-txt-lg font-semibold text-foreground-emphasis">
      {{ resolvedTitle }}
    </h3>

    <p
      class="scrollbar-hide max-h-44 overflow-scroll text-mgm-txt-sm font-normal text-foreground-default"
      v-html="resolvedDescription"
    ></p>

    <BaseButton
      class="mt-6 w-full"
      :text="$t('generic.doneModalCta')"
      data-cy="btn-close-modal"
      @click="emit('close')"
    />
  </div>
</template>
